"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview5_exports = {};
__export(GeodesPreview5_exports, {
  default: () => GeodesPreview5_default
});
module.exports = __toCommonJS(GeodesPreview5_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.6914 4.05859C16.7826 4.16276 16.8281 4.28646 16.8281 4.42969C16.8281 4.5599 16.7826 4.67057 16.6914 4.76172L5.01172 16.4414C4.92057 16.5326 4.80339 16.5781 4.66016 16.5781C4.52995 16.5781 4.41276 16.5326 4.30859 16.4414C4.21745 16.3372 4.17188 16.2201 4.17188 16.0898C4.17188 15.9466 4.21745 15.8294 4.30859 15.7383L15.9883 4.05859C16.0794 3.96745 16.1901 3.92188 16.3203 3.92188C16.4635 3.92188 16.5872 3.96745 16.6914 4.05859ZM6.75 8.41406C6.21615 8.41406 5.76042 8.23177 5.38281 7.86719C5.01823 7.48958 4.83594 7.03385 4.83594 6.5C4.83594 5.96615 5.01823 5.51693 5.38281 5.15234C5.76042 4.77474 6.21615 4.58594 6.75 4.58594C7.28385 4.58594 7.73307 4.77474 8.09766 5.15234C8.47526 5.51693 8.66406 5.96615 8.66406 6.5C8.66406 7.03385 8.47526 7.48958 8.09766 7.86719C7.73307 8.23177 7.28385 8.41406 6.75 8.41406ZM6.75 9.41016C7.55729 9.41016 8.24089 9.13021 8.80078 8.57031C9.3737 7.9974 9.66016 7.30729 9.66016 6.5C9.66016 5.69271 9.3737 5.00911 8.80078 4.44922C8.24089 3.8763 7.55729 3.58984 6.75 3.58984C5.94271 3.58984 5.2526 3.8763 4.67969 4.44922C4.11979 5.00911 3.83984 5.69271 3.83984 6.5C3.83984 7.30729 4.11979 7.9974 4.67969 8.57031C5.2526 9.13021 5.94271 9.41016 6.75 9.41016ZM14.25 15.9141C13.7161 15.9141 13.2604 15.7318 12.8828 15.3672C12.5182 14.9896 12.3359 14.5339 12.3359 14C12.3359 13.4661 12.5182 13.0169 12.8828 12.6523C13.2604 12.2747 13.7161 12.0859 14.25 12.0859C14.7839 12.0859 15.2331 12.2747 15.5977 12.6523C15.9753 13.0169 16.1641 13.4661 16.1641 14C16.1641 14.5339 15.9753 14.9896 15.5977 15.3672C15.2331 15.7318 14.7839 15.9141 14.25 15.9141ZM14.25 16.9102C15.0573 16.9102 15.7409 16.6302 16.3008 16.0703C16.8737 15.4974 17.1602 14.8073 17.1602 14C17.1602 13.1927 16.8737 12.5091 16.3008 11.9492C15.7409 11.3763 15.0573 11.0898 14.25 11.0898C13.4427 11.0898 12.7526 11.3763 12.1797 11.9492C11.6198 12.5091 11.3398 13.1927 11.3398 14C11.3398 14.8073 11.6198 15.4974 12.1797 16.0703C12.7526 16.6302 13.4427 16.9102 14.25 16.9102Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview5 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview5_default = SvgGeodesPreview5;
